/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2} from "@mui/material";
import Titulo_Contactos_Home from "./SubComponentes/Titulo_Contactos_Home";
import Lista_Contactos_Home from "./SubComponentes/Lista_Contactos_Home";
import Formulario_Contactos_Home from "./SubComponentes/Formulario_Contactos_Home";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Contactos_Home = () => {


    return (
        <Grid2
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={12}>

            <Grid2 container justifyContent={'center'} size={12}
                   sx={{maxWidth: '1400px', px: 3}}>



                    <Grid2 container size={11}  >

                        <Grid2 container size={{xs: 12, md: 6}}>
                            <Titulo_Contactos_Home/>
                        </Grid2>

                        <Grid2 container size={{xs: 12, md: 6}}>
                        </Grid2>

                    </Grid2>

                    <Grid2 container size={12} sx={{mt:8}}>
                        <Lista_Contactos_Home/>
                    </Grid2>






            </Grid2>

        </Grid2>
    )

}
export default Contactos_Home